import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Intercom from '@intercom/messenger-js-sdk';
import withStyles from '@mui/styles/withStyles';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { withSnackbar } from 'notistack';
import Footer from '../components/common/sign_up/Footer';
import FooterMobile from '../components/common/sign_up/FooterMobile';
import HeaderForm from '../components/common/sign_up/HeaderForm';
import RecruiterRegistration from '../components/sign_up/RecruiterRegistration';
import OrganizationRegistration from '../components/sign_up/OrganizationRegistration';
import OrganizationApproval from '../components/sign_up/OrganizationApproval';
import PushFlashMessages from '../helpers/PushFlashMessages';
import SlideDesktopVersion from '../components/registration/SlideDesktopVersion';
import SlideMobileVersion from '../components/registration/SlideMobileVersion';
import CreateOrganizationConfirmationModal from '../components/sign_up/CreateOrganizationConfirmationModal';

const styles = theme => ({
  mainSignUp: {
    backgroundColor: '#fff',
    width: 'auto',
    display: 'block',
  },
  inputForm: {
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      maxWidth: '50%',
      flexBasis: '50%',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '24px 24px 0 24px',
    },
    [theme.breakpoints.up(1025)]: {
      padding: '32px 72px 0px 72px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '48px 15px 0px 15px',
    },
  },
  gridSlide: {
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      maxWidth: '50%',
      flexBasis: '50%',
    },
  },
  gridMobile: {
    background: '#F2F2F2',
    padding: '15px 15px 42px 15px',
  },
});

const stepAttributes = (location, enqueueSnackbar) => {
  const attributes = {
    activeStep: 0,
    stepComponent: <RecruiterRegistration enqueueSnackbar={enqueueSnackbar} />,
  };

  switch (location.pathname) {
    case '/recruiter/organization/new':
      attributes.activeStep = 1;
      attributes.stepComponent = <OrganizationRegistration />;
      break;
    case '/recruiter/organization':
      attributes.activeStep = 2;
      attributes.stepComponent = <OrganizationApproval />;
      break;
    default:
  }
  return attributes;
};

function specifyAction(step) {
  let action = '';
  switch (step) {
    case 0:
      action = 'personalRegistration';
      break;
    case 1:
      action = 'organizationRegistration';
      break;
    case 2:
      action = 'waitingApproval';
      break;
    default:
  }
  return action;
}

const SignUpSteppers = ({ classes, location, enqueueSnackbar }) => {
  const { activeStep, stepComponent } = stepAttributes(location, enqueueSnackbar);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  PushFlashMessages(enqueueSnackbar);
  useEffect(() => {
    Intercom({
      intercom_user_jwt: window.gon.intercom.user_jwt,
      app_id: window.gon.intercom.app_id,
    });
  }, []);

  useEffect(() => {
    if (activeStep === 0) {
      setShowConfirmationModal(true);
    }
  }, [activeStep]);

  return (
    <React.Fragment>
      <main className={classes.mainSignUp}>
        <Grid container alignItems="stretch">
          <Hidden only="xs">
            <Grid item xs={12} sm={5} className={classes.gridSlide}>
              <SlideDesktopVersion />
            </Grid>
          </Hidden>
          <Grid item xs={12} sm={7} className={classes.inputForm}>
            <CssBaseline />
            <HeaderForm linkType={specifyAction(activeStep)} />
            {stepComponent}
            <Footer linkType={activeStep === 0 ? 'signIn' : ''} />
          </Grid>
          <Hidden only={['sm', 'lg', 'md', 'xl']}>
            <Grid
              item
              xs={12}
              className={classes.gridMobile}
            >
              <SlideMobileVersion />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <FooterMobile />
            </Grid>
          </Hidden>
        </Grid>
      </main>
      <CreateOrganizationConfirmationModal
        open={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
      />
    </React.Fragment>
  );
};

SignUpSteppers.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default withStyles(styles)(withSnackbar(SignUpSteppers));
